import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const Post = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // Query by slug field instead of document ID
        const q = query(
          collection(db, 'partners'), 
          where('slug', '==', slug),
          where('published', '==', true)
        );
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          const postData = { id: doc.id, ...doc.data() };
          setPost(postData);
        } else {
          setError('Post not found');
        }
      } catch (err) {
        console.error('Error fetching post:', err);
        setError('Failed to load post');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPost();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading post...</p>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Post Not Found</h1>
          <p className="text-gray-600">{error || 'The requested post could not be found.'}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Page container */}
      <article className="max-w-5xl mx-auto px-6 lg:px-8 py-10 lg:py-20">
        {/* Eyebrow + headline */}
        <header className="mb-10 lg:mb-16">
          <p className="text-sm text-center text-black/70 mb-4">
            Partnerships • {new Date(post.date).toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>

          <h1 className="text-3xl text-center lg:text-6xl font-semibold tracking-tight text-black mb-6">
            {post.title}
          </h1>
        </header>

        {/* Hero banner */}
        <figure className="mb-16 lg:mb-20">
          <img
            src={post.image}
            alt={`${post.title} banner`}
            className="w-full rounded-2xl border border-black/10"
          />
        </figure>

        {/* Post body */}
        <section className="prose prose-lg max-w-none text-black">
          <div dangerouslySetInnerHTML={{ __html: post.body }} />
        </section>

        {/* Author & date */}
        <footer className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">By {post.author}</p>
              <p className="text-sm text-gray-500">
                Published {new Date(post.date).toLocaleDateString()}
              </p>
            </div>
          </div>
        </footer>
      </article>
    </div>
  );
};

export default Post;